import { useContext } from 'react';
import { TagContext } from './TagContext';

export const useWebsiteData = () => {
  const { loading, tagData } = useContext(TagContext);

  return loading ? {} : { urlHistory: tagData?.urlHistory };
};
